import { computed } from 'vue';
import { STORAGE_PLATFORM_KEY } from '@os-web/const';

declare global {
  interface Window {
    mmc?: {
      client: {
        isAPP?: () => boolean;
        is?: (name: string) => boolean;
        goto?: (options: unknown, callback?: () => void) => void;
        getInfo?: () => Record<string, unknown>;
      };
      user?: {
        getInfo?: () => Record<string, unknown>;
      };
      init?: () => void;
      ready?: (callback: () => void) => void;
      afterReady?: unknown;
    };
    __wxjs_environment?: string;
  }
}

export function isInApp() {
  if (!window.mmc?.client.isAPP?.()) return false;

  const appList = ['ljds', 'ydk'];
  return appList.some((name) => !!window.mmc?.client.is?.(name));
}

export const isApp = isInApp();

export const isWhistStar = computed(() => {
  return ['220', '221'].includes(localStorage.getItem(STORAGE_PLATFORM_KEY) || '');
});

export function goAppModule({
  action = 110,
  global_type,
  func_type,
  data,
  callBack,
  config,
}: {
  action?: number;
  global_type?: unknown;
  func_type?: unknown;
  data?: unknown;
  callBack?: () => void;
  config?: {
    closeWindow?: boolean;
    closeAllWindow?: boolean;
    needRefresh?: boolean;
    needCallback?: boolean;
  };
}) {
  const { closeWindow, needRefresh, needCallback, closeAllWindow } = {
    closeWindow: false,
    closeAllWindow: false,
    needRefresh: true,
    needCallback: true,
    ...config,
  };

  window.mmc?.client.goto?.(
    {
      params: {
        action,
        actioncontent: {
          global_type,
          func_type,
          data: data || {},
        },
        closeWindow,
        closeAllWindow,
        needRefresh,
        needCallback,
      },
    },
    callBack,
  );
}

export function openAppWebview(
  link: string,
  { redirect = false, callBack }: { redirect?: boolean; callBack?: () => void } = {},
) {
  goAppModule({
    action: 102,
    global_type: link,
    config: {
      closeWindow: !!redirect,
    },
    callBack,
  });
}

export function getAppUserInfo() {
  return window.mmc?.user?.getInfo?.() || {};
}

export function getAppDeviceInfo() {
  return window.mmc?.client.getInfo?.() || {};
}

export async function appPromiseInit() {
  if (window.mmc?.afterReady) return;

  window.mmc?.init?.();

  return new Promise<void>((resolve) => {
    window.mmc?.ready?.(resolve);
  });
}
